import { csrfToken } from 'modules/csrf';

function executeScript(body) {
  const script = document.createElement('script');
  script.textContent = body;
  document.head.appendChild(script);
  script.remove();
}

function remoteHeaders(form) {
  const headers = {
    Accept: 'text/javascript, application/javascript, application/ecmascript, text/x-ecmascript, */*; q=0.01',
    'X-Requested-With': 'XMLHttpRequest'
  };

  const token = csrfToken();
  if (token) headers['X-CSRF-Token'] = token;

  const dataType = form?.dataset?.type;
  if (dataType === 'json') {
    headers.Accept = 'application/json, text/javascript, */*; q=0.01';
  }

  return headers;
}

async function performRemoteRequest(url, { method = 'GET', body = null, form = null } = {}) {
  const response = await fetch(url, {
    method,
    body,
    credentials: 'same-origin',
    headers: remoteHeaders(form)
  });

  if (!response.ok) return;

  const contentType = response.headers.get('Content-Type') || '';
  const text = await response.text();
  if (!text) return;

  if (contentType.includes('javascript') || text.trimStart().startsWith('window.') || text.trimStart().startsWith('$')) {
    executeScript(text);
    return;
  }

  if (contentType.includes('json')) {
    executeScript(text);
  }
}

function serializeForm(form) {
  const method = (form.getAttribute('method') || 'get').toLowerCase();
  const action = form.getAttribute('action') || window.location.href;

  if (method === 'get') {
    const params = new URLSearchParams(new FormData(form));
    const separator = action.includes('?') ? '&' : '?';
    return { url: `${action}${separator}${params.toString()}`, method: 'GET', body: null };
  }

  return { url: action, method: method.toUpperCase(), body: new FormData(form) };
}

export function installRailsRemote() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-remote]');
    if (!link || link.dataset.remote === 'false') return;

    event.preventDefault();
    performRemoteRequest(link.href, { method: 'GET' });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-remote]');
    if (!form || form.dataset.remote === 'false') return;
    if (form.dataset.controller?.includes('remote-json-form')) return;

    event.preventDefault();
    const { url, method, body } = serializeForm(form);
    performRemoteRequest(url, { method, body, form });
  });
}
